import { SPECIAL_RULES } from "../constants/config";
import { KKE_FORM_INITIAL_VALUES } from "../constants/klientkontoerklaering/initialValues";
import { KlientkontoerklaeringFormValues } from "../interfaces/klientkontoerklaering";

export const getNonMatchingStrings = (
  searchString: string,
  keys: string[],
  exceptions: string[] = [],
): string[] => {
  const nonMatchingStrings: string[] = [];

  keys.forEach((key: string) => {
    if (!key.startsWith(searchString)) {
      nonMatchingStrings.push(key);
    }
  });

  const finalNonMatchingStrings = nonMatchingStrings.filter(
    (key) => !exceptions.includes(key),
  );

  return finalNonMatchingStrings;
};

export const replaceNonMatchingWithDefaults = (
  values: KlientkontoerklaeringFormValues,
  nonMatchingFields: string[],
) => {
  const updatedValues = { ...values };

  nonMatchingFields.forEach((field) => {
    if (updatedValues.hasOwnProperty(field)) {
      switch (typeof updatedValues[field]) {
        case "object":
          updatedValues[field] = [
            replaceUndefinedValues(KKE_FORM_INITIAL_VALUES[field][0]),
          ];
          break;
        case "string":
          updatedValues[field] = "";
          break;
        default:
          updatedValues[field] = KKE_FORM_INITIAL_VALUES[field];
          break;
      }
    }
  });

  return updatedValues;
};

export const shortenToTwoDigits = (inputString: string, i: number): string => {
  if (i > 12) {
    const matches = inputString.match(/^(.*?\d[^_]*?_.*?\d)/);
    return matches ? matches[0] : inputString;
  } else {
    const matches = inputString.match(/^(.*?\d.*?\d)/);
    return matches ? matches[0] : inputString;
  }
};

export const specialRule = (searchString: string): string[] =>
  SPECIAL_RULES[searchString];

const replaceUndefinedValues = (obj: any) => {
  Object.keys(obj).forEach((key) => {
    if (obj[key] === undefined) {
      obj[key] = "";
    }
  });
  return obj;
};
